"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
exports.default = (function (_a) {
    var group = _a.group, onClick = _a.onClick, groupContent = _a.groupContent, withSubGroups = _a.withSubGroups;
    if (withSubGroups && group.childrens) {
        var onGroupClick = void 0;
        if (onClick) {
            onGroupClick = function () { return onClick(group); };
        }
        var classNames_1 = classnames_1.default("group", "root", {
            open: group.open,
            close: !group.open,
            empty: group.childrens.length === 0,
        });
        return (react_1.default.createElement("div", { onClick: onGroupClick, className: classNames_1 }, groupContent ? groupContent({ group: group }) : group.title));
    }
    else {
        return (react_1.default.createElement("div", { className: classnames_1.default("group", group.className, { subgroup: withSubGroups }) }, groupContent ? groupContent({ group: group }) : group.title));
    }
});
//# sourceMappingURL=index.js.map